(function () {
  const prev = window.wishlistEngineCallback;

  window.wishlistEngineCallback = function (response) {
    if (typeof prev === 'function') {
      try { prev(response); } catch (e) { console.warn('prior wishlistEngineCallback threw', e); }
    }
    if (!response || !Array.isArray(response.items)) return;
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true,
        cancelable: false,
        detail: { source: 'wishlist-engine', cart: response }
      }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        bubbles: true,
        cancelable: false,
        detail: { source: 'wishlist-engine' }
      }));
    }, 0);
  };
})();
